<template xmlns="http://www.w3.org/1999/html">
  <loader-content :ref="(el: any) => loader = el">
  <div class="d-flex flex-column email-login">
    <div class="text-center">
      <h1>{{ $t('create_new_password')}}</h1>
    </div>
    <div class="text-center">
      <span class="info">{{$t('for_email', {email: state.email})}}</span>
    </div>
    <div class="d-flex flex-column gap-sm">
      <div class="">
        <label for="password" class="form-label text-capitalize-first">{{ $t('password') }}</label>
        <input v-model="state.password" id="password" type="password" class="form-control" :placeholder="$t('enter_new_password')">
      </div>
    </div>
    <div>
      <button @click.prevent="save()" class="btn btn-primary w-100 btn-lg">{{$t('save')}}</button>
    </div>
  </div>
  </loader-content>
</template>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";
import {useRoute} from "vue-router";
import LoaderContent from "@/components/LoaderContent.vue";
import TokenGetRequestDTO from "@/models/request/TokenGetRequestDTO";
import {tryOpenApp} from "@/service/appDeepLink";

const state = reactive({
  password: '' as string,
  token: null as string|null,
  email: '' as string
});

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const store = useStore()
const route = useRoute()
const notification = useNotification()

const save = async () => {
  loader.value?.load(async () => {
    try {
      await api.call.token.changePassword(state.token as string, state.password)
      const token = await api.call.token.get({ username: state.email, password: state.password } as TokenGetRequestDTO)
      notification.notify({type: 'success', title: $t('notifications.password_changed'), duration: 1500})
      setTimeout(async () => {
        await store.dispatch('authenticate', token)
        window.location.href = '/'
      }, 1000)
    } catch (e) {
      notification.notify({type: 'error', title: $t('notifications.password_change_error'), duration: 1500})
    }
  });
}

onMounted(async () => {
  loader.value?.load(async () => {
    state.token = route.params.token as string
    if (await tryOpenApp(`password-reset/${state.token}`)) {
      return
    }
    try {
      const data = await api.call.token.resetPasswordGetToken(state.token)
      state.email = data.email
    } catch (e) {
      notification.notify({type: 'error', title: $t('notifications.password_reset_invalid_link'), duration: 1500})
    }
  });

})

</script>
